/* Perfil de quem entrou: define se é admin ou captador.
   O isolamento de verdade está nas policies do Postgres, não aqui.
   Isto só ajusta o que aparece na tela. */
import { sb } from "../supabase.js";
import { S } from "../estado.js";
import { $, toast } from "../util.js";

export async function carregarPerfil(){
  /* select * de propósito. A linha é a do próprio usuário, então não pesa,
     e assim o painel não quebra se alguma migração ainda não tiver rodado
     no banco: pedir uma coluna que não existe derruba a consulta inteira. */
  const { data, error } = await sb
    .from("perfis")
    .select("*")
    .eq("id", S.usuario.id)
    .maybeSingle();

  if (error || !data){
    /* Sem linha em perfis, trata como captador: é o papel que menos enxerga. */
    S.perfil = {
      id: S.usuario.id,
      email: S.usuario.email,
      nome: (S.usuario.email || "").split("@")[0],
      papel: "captador"
    };
    toast("Perfil não encontrado. Avise quem administra o painel.");
  } else {
    S.perfil = data;
  }

  S.souAdmin = S.perfil.papel === "admin";

  const selo = $("#quemSou");
  if (selo){
    selo.hidden = false;
    selo.textContent = S.souAdmin ? "Admin" : (S.perfil.nome || S.perfil.email);
    selo.classList.toggle("adm", S.souAdmin);
  }

  /* Só o admin carrega a lista da equipe. Para o captador, a própria policy
     do Postgres devolveria apenas ele mesmo de qualquer forma. */
  if (S.souAdmin){
    const r = await sb.from("perfis").select("*").order("nome");
    /* Blindagem: qualquer formato inesperado vira lista, senão a ficha quebra. */
    S.equipe = Array.isArray(r.data) ? r.data : (r.data ? [r.data] : []);
  } else {
    S.equipe = [S.perfil];
  }
}
